import buildService, { NoParams } from 'common/utils/build-service'
import { GET } from 'common/requests'

export default buildService<NoParams, unknown, unknown, unknown>({
  type: GET,
  constantsPrefix: 'PHASES',
  isArray: true,
  http: {
    createApiUrlSuffix: () => '/phases?select=id,name',
  },
})
